<template>
  <div class="forgot-container">
    <div class="forgot-box">
      <h1 class="forgot-title">{{ $t('forgotPassword.title') }}</h1>

      <el-steps :active="activeStep" align-center class="steps">
        <el-step :title="$t('forgotPassword.step1')"></el-step>
        <el-step :title="$t('forgotPassword.step2')"></el-step>
        <el-step :title="$t('forgotPassword.step3')"></el-step>
      </el-steps>

      <div v-if="activeStep === 1" class="step-content">
        <el-form
          ref="emailForm"
          :model="forgotForm"
          :rules="emailRules"
          class="forgot-form"
        >
          <el-form-item prop="email">
            <el-input
              v-model="forgotForm.email"
              :placeholder="$t('forgotPassword.emailPlaceholder')"
              prefix-icon="el-icon-message"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="forgot-btn"
              :loading="loading"
              @click="sendVerifyCode"
            >
              {{ $t('forgotPassword.sendCode') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="activeStep === 2" class="step-content">
        <el-form
          ref="passwordForm"
          :model="forgotForm"
          :rules="passwordRules"
          class="forgot-form"
        >
          <el-form-item prop="verifyCode">
            <el-input
              v-model="forgotForm.verifyCode"
              :placeholder="$t('forgotPassword.verifyCodePlaceholder')"
              prefix-icon="el-icon-key"
            ></el-input>
          </el-form-item>

          <el-form-item prop="newPassword">
            <el-input
              v-model="forgotForm.newPassword"
              type="password"
              :placeholder="$t('forgotPassword.newPasswordPlaceholder')"
              prefix-icon="el-icon-lock"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="forgot-btn"
              :loading="loading"
              @click="resetPassword"
            >
              {{ $t('forgotPassword.resetPassword') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="activeStep === 3" class="step-content">
        <div class="success-message">
          <i class="el-icon-success" style="font-size: 50px; color: #67C23A;"></i>
          <h2>{{ $t('forgotPassword.successTitle') }}</h2>
          <p>{{ $t('forgotPassword.successMessage') }}</p>
          <el-button
            type="primary"
            @click="goToLogin"
          >
            {{ $t('forgotPassword.backToLogin') }}
          </el-button>
        </div>
      </div>

      <div class="forgot-footer">
        <span @click="goToLogin">{{ $t('forgotPassword.backToLogin') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      activeStep: 1,
      forgotForm: {
        email: '',
        verifyCode: '',
        newPassword: ''
      },
      loading: false,
      countdown: 0,
      timer: null
    }
  },
  computed: {
    // 动态验证规则
    emailRules() {
      return {
        email: [
          { required: true, message: this.$t('forgotPassword.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('forgotPassword.emailFormatError'), trigger: ['blur', 'change'] }
        ]
      }
    },
    passwordRules() {
      return {
        verifyCode: [
          { required: true, message: this.$t('forgotPassword.verifyCodeRequired'), trigger: 'blur' },
          { len: 6, message: this.$t('forgotPassword.verifyCodeLengthError'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('forgotPassword.newPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('forgotPassword.passwordLengthError'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    sendVerifyCode() {
      this.$refs.emailForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 模拟发送验证码
          setTimeout(() => {
            this.loading = false
            this.$message.success(this.$t('forgotPassword.codeSent'))
            this.activeStep = 2
            this.startCountdown()
          }, 1000)
        }
      })
    },
    resetPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 模拟重置密码
          setTimeout(() => {
            this.loading = false
            this.activeStep = 3
          }, 1000)
        }
      })
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    goToLogin() {
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.forgot-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  background-image: url("@/assets/index/bc.jpg");
  background-size: cover;
  background-position: center;
}

.forgot-box {
  width: 90%;
  max-width: 500px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.forgot-title {
  margin-bottom: 20px;
  text-align: center;
  color: #333;
  font-size: 24px;
}

.steps {
  margin-bottom: 30px;
}

.step-content {
  margin-bottom: 20px;
}

.forgot-form {
  margin-top: 20px;
}

.forgot-btn {
  width: 100%;
}

.success-message {
  text-align: center;
  padding: 20px 0;
}

.success-message h2 {
  margin: 20px 0 10px;
  color: #67C23A;
}

.forgot-footer {
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #666;
  margin-top: 20px;
}

.forgot-footer span {
  cursor: pointer;
  transition: color 0.3s;
}

.forgot-footer span:hover {
  color: #409EFF;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .forgot-box {
    width: 85%;
    padding: 20px;
  }

  .forgot-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .forgot-box {
    width: 90%;
    padding: 15px;
  }

  .forgot-title {
    font-size: 18px;
  }

  .steps {
    margin-bottom: 20px;
  }
}
</style>